import React, { useState, useEffect, useMemo } from 'react'
import { Box, Grid } from '@mui/material';
import * as TaskServices from '../../../services/task-services.proxy';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import TaskDetailsContainer from '../../../components/Dashboard/ManageTasks/TaskDetailsContainer';
import { useLocation, useNavigate } from 'react-router-dom';
import { getDialogLoadingState, getLoadingState, setDialogLoading, setLoading } from '../../../app/slices/loadingSlice';
import { getCallStatus, getErrorMsg, setActionCallFrom, setCallStatus, setErrorMsg } from '../../../app/slices/apiCallSlice';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import moment from 'moment';
import { getModifyValue, setModify } from '../../../app/slices/modifySlice';
import * as commentServices from "../../../services/comment-service.proxy";
import Unauthorized from '../../../sharedComponents/Unauthorized';
import { selectUserType } from '../../../app/slices/userDataSlice';
import CreateTask from '../../../components/Dashboard/ManageTasks/CreateTask';
import DeleteDialog from '../../../sharedComponents/Dialogs/DeleteDialog';
import * as ReminderServices from '../../../services/reminder-services.proxy';
import * as NotificationServices from "../../../services/notification-services.proxy";
import * as StatusesConsts from "../../../status-consts";
import CustomRecurringDialog from '../../../components/Dashboard/ManageTasks/CustomRecurringDialog';

export interface RightDrawer {
  openRightDrawer: any;
  setOpenRightDrawer: any
}
const TaskDetails = (props: RightDrawer) => {
  const {
    openRightDrawer,
    setOpenRightDrawer
  }=props

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const getTaskById = TaskServices.getTaskById;
  const updateTask = TaskServices.updateTask;
  const getTaskInputData = TaskServices.getTaskInputData;
  const getTaskListInputData = TaskServices.getTaskListInputData;
  const addComment = commentServices.addComment;
  const moveDocumentToDatev = commentServices.moveDocumentToDatev;
  const uploadTaskDocument = TaskServices.uploadTaskDocument;
  const deleteTaskDocument = TaskServices.deleteTaskDocument;
  const deleteTask = TaskServices.deleteTask
  const duplicateTask = TaskServices.duplicateTask;
  const addTask = TaskServices.addTask;
  const updateTaskStatus = TaskServices.updateTaskStatus;
  const moveAttachmentsToDatev = TaskServices.moveAttachmentsToDatev;
  const postCustomRecurring = TaskServices.postCustomRecurring;
  const downloadFile = TaskServices.downloadFile;

  const userNotifications = NotificationServices.userNotifications;

  const postReminder = ReminderServices.postReminder;
  const inActiveReminder = ReminderServices.inActiveReminder;

  const useQuery = () => {
    const { search } = useLocation();
    return useMemo(() => new URLSearchParams(search), [search]);
  };
  const query = useQuery();
  const taskId = query.get("id");

  //dispatched states
  const dialogLoading = useAppSelector(getDialogLoadingState);
  const modify = useAppSelector(getModifyValue);
  const userType = useAppSelector(selectUserType);
  const [firstRender, setFirstRender] = useState(true);

  //comment states
  const [commentLoading, setCommentLoading] = useState(false);
  const [commentTxt, setCommentTxt] = useState<string>('');
  const [commentFiles, setCommentFiles] = useState<File[]>([]);
  const [commentReplyTxt, setCommentReplyTxt] = useState<string>('');
  const [commentReplyFiles, setCommentReplyFiles] = useState<File[]>([]);
  const [isFocused, setIsFocused] = useState(false);
  const [isFocused1, setIsFocused1] = useState(false);
  const [isFocused2, setIsFocused2] = useState(false);
  const [movingToDatevLoading, setMovingToDatevLoading] = useState(false);

  //data to be filled 
  const [taskDetails, setTaskDetails] = useState<any>();
  const [assigneesList, setAssigneesList] = useState<any>();
  const [internalAssigneesList, setInternalAssigneesList] = useState([]);
  const [externalAssigneesList, setExternalAssigneesList] = useState([]);
  const [clientsList, setClientsList] = useState<any>();
  const [typesList, setTypesList] = useState<any>();
  const [moduleList, setModuleList] = useState<any>();
  const [statusesList, setStatusesList] = useState<any>();
  const [historyCategoriesList, setHistoryCategoriesList] = useState<any>();
  const [recurringPeriodsList, setRecurringPeriodsList] = useState<any>();
  const [remindersList, setRemindersList] = useState<any>();
  const [recurringObject, setRecurringObject] = useState<any>({
    taskId: taskId,
    days: [],
    isEnding: true,
    endDate: null,
    endRecurranceNumber: null
  });
  const [originalRecurringObject, setOriginalRecurringObject] = useState<any>({
    taskId: taskId,
    days: [],
    isEnding: true,
    endDate: null,
    endRecurranceNumber: null
  });

  //extra uninque loading states to not interfere with others
  const [initiallistLoading, setInitialListLoading] = useState(false);
  const [inputDataLoading, setInputDataLoading] = useState(false);

  const [unAuthorized, setUnAuthorized] = useState(false);

  //files
  const [files, setFiles] = useState<File[]>([]);
  const [fileLoading, setFileLoading] = useState('');

  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [selectedTaskToDelete, setselectedTaskToDelete] = useState<any>();
  const [openAddTaskDialog, setOpenAddTaskDialog] = useState(false);
  const [taskObject, setTaskObject] = useState({
    title: "",
    dueDate: "",
    startDate: "",
    endDate: "",
    description: "",
    status: 1,
    type: 1,
    module: 1,
    clientId: localStorage.getItem('userType') === '1' ? "" : null,
    assigneeId: "",
    priority: 3,
    recurringPeriod: 0,
    note: ""
  })

  const [openCustomReminder, setOpenCustomReminder] = useState(false);
  const [docError, setDocError] = useState('');

  //custom recurring
  const [openCustomRecurringDialog, setOpenCustomRecurringDialog] = useState(false);
  const [onBoardingDetails, setOnBoardingDetails] = useState<any>([
    {
        id: 1,
        nameGR: 'Persönliche Angaben',
        nameEn: 'Personal Declarations',
        Sections: [
            {
                id: 1,
                key: "reportingData",
                nameGR: 'Meldedaten',
                nameEn: 'Reporting data',
                statusEn: 'In Progress',
                statusGR: '',
                fields: [
                    {
                        id: 1,
                        key: 'insuranceNb',
                        nameGR: 'Versicherungsnummer gem. Sozialvers.-Ausweis',
                        nameEn: 'Insurance number according to social insurance card',
                        value: 'test',
                        type: 'textfield',
                        xs: 12,
                        relatedFieldsIds: [],
                        dependantId: null,
                    },
                    {
                        id: 2,
                        key: 'birthName',
                        nameGR: 'Geburtsname',
                        nameEn: 'Birth name',
                        value: 'test',
                        type: 'textfield',
                        xs: 12,
                        relatedFieldsIds: [],
                        dependantId: null,
                    },
                    {
                        id: 3,
                        key: 'birthDate',
                        nameGR: 'Geburtsdatum',
                        nameEn: 'Birth date',
                        value: "4/19/2025",
                        type: 'dateTextfield',
                        xs: 12,
                        relatedFieldsIds: [],
                        dependantId: null,
                    },
                    {
                        id: 4,
                        key: 'street',
                        nameGR: 'Straße',
                        nameEn: 'Street',
                        value: 'test',
                        type: 'textfield',
                        xs: 6,
                        relatedFieldsIds: [],
                        dependantId: null,
                    },
                    {
                        id: 5,
                        key: 'houseNb',
                        nameGR: 'Hausnummer',
                        nameEn: 'House number',
                        value: 'test',
                        type: 'textfield',
                        xs: 6,
                        relatedFieldsIds: [],
                        dependantId: null,
                    },
                    {
                        id: 6,
                        key: 'postalCode',
                        nameGR: 'Postleitzahl',
                        nameEn: 'Postal code',
                        value: 'test',
                        type: 'textfield',
                        xs: 6,
                        relatedFieldsIds: [],
                        dependantId: null,
                    },
                    {
                        id: 7,
                        key: 'location',
                        nameGR: 'Ort',
                        nameEn: 'Location',
                        value: 'test',
                        type: 'textfield',
                        xs: 6,
                        relatedFieldsIds: [],
                        dependantId: null,
                    },
                    {
                        id: 8,
                        key: 'addressSuplement',
                        nameGR: 'Anschriftenzusatz',
                        nameEn: 'Address supplement',
                        value: 'test',
                        type: 'textfield',
                        xs: 12,
                        relatedFieldsIds: [],
                        dependantId: null,
                    },
                    {
                        id: 9,
                        key: 'land',
                        nameGR: 'Land',
                        nameEn: 'Land',
                        value: 'test',
                        type: 'textfield',
                        xs: 12,
                        relatedFieldsIds: [],
                        dependantId: null,
                    },
                    {
                        id: 10,
                        key: 'placeOfBirth',
                        nameGR: 'Geburtsort',
                        nameEn: 'Place of birth',
                        value: 'test',
                        type: 'textfield',
                        xs: 6,
                        relatedFieldsIds: [],
                        dependantId: null,
                    },
                    {
                        id: 11,
                        key: 'countryOfBirth',
                        nameGR: 'Geburtsland',
                        nameEn: 'Country of birth',
                        value: 'test',
                        type: 'textfield',
                        xs: 6,
                        relatedFieldsIds: [],
                        dependantId: null,
                    },
                    {
                        id: 12,
                        key: "gender",
                        nameGR: 'Geschlecht',
                        nameEn: 'Gender',
                        value: 'test',
                        type: 'textfield',
                        xs: 6,
                        relatedFieldsIds: [],
                        dependantId: null,
                    },
                    {
                        id: 13,
                        key: 'isObligedtoSubmitImmediateReports',
                        nameGR: 'Unternehmen zur Abgabe von Sofortmeldungen verpflichtet',
                        nameEn: 'Companies are obliged to submit immediate reports',
                        value: false,
                        type: 'switch',
                        xs: 12,
                        relatedFieldsIds: [],
                        dependantId: null,
                    },
                    {
                        id: 14,
                        key: 'isNonEUCountry',
                        nameGR: 'Is Nationality of a non-EU Country?',
                        nameEn: 'Ist die Staatsangehörigkeit eines Nicht-EU-Landes?',
                        value: true,
                        type: 'switch',
                        xs: 12,
                        relatedFieldsIds: [15, 16],
                        dependantId: null,
                    },
                    {
                        id: 15,
                        key: "isWorkPermit",
                        nameGR: 'Arbeitserlaubnis liegt vor?',
                        nameEn: 'Do you have a work permit?',
                        value: true,
                        type: 'switch',
                        xs: 12,
                        relatedFieldsIds: [16, 17, 18],
                        dependantId: 14,
                    },
                    {
                        id: 16,
                        key: "workPermitFile",
                        nameGR: 'Arbeitserlaubnis',
                        nameEn: 'Work Permit',
                        value: 'test',
                        type: 'textfield',
                        xs: 12,
                        relatedFieldsIds: [],
                        dependantId: 15,
                    },
                    {
                        id: 17,
                        key: "workPermitFile",
                        nameGR: 'Arbeitserlaubnis gültig bis',
                        nameEn: 'Work permit valid until',
                        value: "4/21/2025",
                        type: 'dateTextfield',
                        xs: 12,
                        relatedFieldsIds: [],
                        dependantId: 15,
                    },
                    {
                        id: 18,
                        key: "workPermitFile",
                        nameGR: 'Aufenthaltsgenehmigung gültig bis',
                        nameEn: 'Residence permit valid until',
                        value: "9/21/2025",
                        type: 'dateTextfield',
                        xs: 12,
                        relatedFieldsIds: [],
                        dependantId: 15,
                    },
                ]
            },
            {
                id: 2,
                key: "bankDetails",
                nameGR: 'Bankdaten',
                nameEn: 'Bank details',
                statusEn: 'In Progress',
                statusGR: '',
                fields: [
                    {
                        id: 1,
                        key: 'iban',
                        nameGR: 'IBAN',
                        nameEn: 'IBAN',
                        value: 'test',
                        type: 'textfield',
                        xs: 12,
                        relatedFieldsIds: [],
                        dependantId: null,
                    },
                    {
                        id: 2,
                        key: 'bic',
                        nameGR: 'BIC',
                        nameEn: 'BIC',
                        value: 'test',
                        type: 'textfield',
                        xs: 12,
                        relatedFieldsIds: [],
                        dependantId: null,
                    },
                    {
                        id: 3,
                        key: 'diffAccountHolder',
                        nameGR: 'ggf. abweichender Kontoinhaber',
                        nameEn: 'Possibly different account holder',
                        value: 'test',
                        type: 'textfield',
                        xs: 12,
                        relatedFieldsIds: [],
                        dependantId: null,
                    },
                ]
            },
            {
                id: 3,
                key: "constructionWages",
                nameGR: 'Baulohn',
                nameEn: 'Construction wages',
                statusEn: 'In Progress',
                statusGR: '',
                fields: [
                    {
                        id: 1,
                        key: 'socialFundEmployeenb',
                        nameGR: 'Arbeitnehmernummer Sozialkasse',
                        nameEn: 'Social fund employee number',
                        value: 'test',
                        type: 'textfield',
                        xs: 12,
                        relatedFieldsIds: [],
                        dependantId: null,
                    },
                    {
                        id: 2,
                        key: 'workInConstructionSince',
                        nameGR: 'Im Baugewerbe Beschäftigt seit',
                        nameEn: 'Worked in the construction industry since',
                        value: "4/21/2025",
                        type: 'dateTextfield',
                        xs: 12,
                        relatedFieldsIds: [],
                        dependantId: null,
                    },

                ]
            },
            {
                id: 4,
                key: "education",
                nameGR: 'Bildung',
                nameEn: 'Education',
                statusEn: 'In Progress',
                statusGR: '',
                fields: [
                    {
                        id: 1,
                        key: 'highestSchoolDegree',
                        nameGR: 'Höchster Schulabschluss',
                        nameEn: 'Highest school degree',
                        value: 'test',
                        type: 'textfield',
                        xs: 12,
                        relatedFieldsIds: [],
                        dependantId: null,
                    },
                    {
                        id: 2,
                        key: 'highestProfessionalQualification',
                        nameGR: 'Höchster Berufsabschluss',
                        nameEn: 'Highest professional qualification',
                        value: 'test',
                        type: 'textfield',
                        xs: 12,
                        relatedFieldsIds: [],
                        dependantId: null,
                    },

                ]
            },
            {
                id: 5,
                key: "difficultDisability",
                nameGR: 'Schwer-behinderung',
                nameEn: 'Difficult-disability',
                statusEn: 'In Progress',
                statusGR: '',
                fields: [
                    {
                        id: 1,
                        key: 'isSevereDisability',
                        nameGR: 'Liegt eine Schwerbehinderung vor?',
                        nameEn: 'Is there a severe disability?',
                        value: true,
                        type: 'switch',
                        xs: 12,
                        relatedFieldsIds: [2, 3,4,5,6,7],
                        dependantId: null,
                    },
                    {
                        id: 2,
                        key: 'severelyDisabledCardFile',
                        nameGR: 'Schwerbehindertenausweis',
                        nameEn: 'Severely disabled ID card',
                        value: 'test',
                        type: 'textfield',
                        xs: 12,
                        relatedFieldsIds: [],
                        dependantId: 1,
                    },
                    {
                        id: 3,
                        key: 'severeDisabilityValidFrom',
                        nameGR: 'Schwerbehinderung gültig ab',
                        nameEn: 'Severe disability valid from',
                        value: "4/19/2025",
                        type: 'dateTextfield',
                        xs: 12,
                        relatedFieldsIds: [],
                        dependantId: 1,
                    },
                    {
                        id: 4,
                        key: 'severeDisabilityValidUntil',
                        nameGR: 'Schwerbehinderung gültig bis',
                        nameEn: 'Severe disability valid until',
                        value: "8/19/2025",
                        type: 'dateTextfield',
                        xs: 12,
                        relatedFieldsIds: [],
                        dependantId: 1,
                    },
                    {
                        id: 5,
                        key: 'degreeOfSevereDisability',
                        nameGR: 'Grad der Schwerbehinderung',
                        nameEn: 'Degree of severe disability',
                        value: 'test',
                        type: 'textfield',
                        xs: 12,
                        relatedFieldsIds: [],
                        dependantId: 1,
                    },
                    {
                        id: 6,
                        key: 'idNb',
                        nameGR: 'Ausweis-Nr. / Akten- oder Geschäftszeichen',
                        nameEn: 'ID number / File or business symbols',
                        value: 'test',
                        type: 'textfield',
                        xs: 12,
                        relatedFieldsIds: [],
                        dependantId: 1,
                    },
                    {
                        id: 7,
                        key: 'issuingOffice',
                        nameGR: 'Austellende Dienststelle',
                        nameEn: 'Issuing office',
                        value: 'test',
                        type: 'textfield',
                        xs: 12,
                        relatedFieldsIds: [],
                        dependantId: 1,
                    },
                    {
                        id: 8,
                        key: 'officeLocation',
                        nameGR: 'Ort der Dienststelle',
                        nameEn: 'Location of the office',
                        value: 'test',
                        type: 'textfield',
                        xs: 12,
                        relatedFieldsIds: [],
                        dependantId: 1,
                    },


                ]
            },


        ]
    },

])

  const errorMsg = useAppSelector(getErrorMsg);
  const loading = useAppSelector(getLoadingState);
  const callStatus = useAppSelector(getCallStatus);

  const [, updateState] = React.useState({});
  const forceUpdate = React.useCallback(() => {
    // Updating state with an empty object to trigger a re-render
    updateState({});
  }, []);

  useEffect(() => {
    //old getTaskInputDataCall();
    // new getTaskListInputDataCall();
    // if (localStorage.getItem('userType') === '2') getTaskListInputDataCall();
    // else
    getTaskByIdCall(null)
  }, [modify]);

  const getTaskByIdCall = (clients: any) => {
    setFirstRender(false)
    if (!taskId) return;
    setInitialListLoading(true);
    getTaskById(taskId).then((x) => {
      if (x.ErrorMessage) {
        dispatch(setErrorMsg(x.ErrorMessage));
        setTimeout(() => {
          dispatch(setErrorMsg(""));
        }, 4500);
      }
      else {
        // let taskObj = {
        //   id: taskId,
        //   title: x.title,
        //   dueDate: moment(x.dueDate, 'M/D/YYYY').format('YYYY-MM-DD'),
        //   status: x.status,
        //   type: x.type,
        //   description: x.description,
        //   clientId: x.clientId,
        //   assigneeId: x.assigneeId,
        //   comments: x.comments,
        //   toBeTagedUsers: x.toBeTagedUsers,
        //   history: x.history
        // }
        // setTaskDetails(taskObj);
        setTaskDetails(x);
        // setTaskDetails((prevDetails: any) => ({
        //   ...prevDetails,
        //   dueDate: moment(x.dueDate, 'DD-MM-YYYY'),
        // }));
        setTaskDetails((prevDetails: any) => ({
          ...prevDetails,
          dueDate: moment(x.dueDate, 'MM/DD/YYYY'),
          startDate: moment(x.startDate, 'MM/DD/YYYY'),
          endDate: moment(x.endDate, 'MM/DD/YYYY'),
        }));
        if(x.survey !== null) setOnBoardingDetails(x.survey)
        setFiles(x.documents);
        if (x.customedRecurring) {
          setRecurringObject(({
            taskId: x.id,
            days: x.customedRecurring.days,
            isEnding: x.customedRecurring.isEnding,
            endDate: x.customedRecurring.endDate,
            endRecurranceNumber: x.customedRecurring.endRecurranceNumber
          }));
          setOriginalRecurringObject(({
            taskId: x.id,
            days: x.customedRecurring.days,
            isEnding: x.customedRecurring.isEnding,
            endDate: x.customedRecurring.endDate,
            endRecurranceNumber: x.customedRecurring.endRecurranceNumber
          }));

        }

        // if (userType === 1) {
        //   const clientTMs = clients?.find((i: any) => i.id === x.clientId)?.users;
        //   setExternalAssigneesList(clientTMs);
        // }
        // if (userType === 1) {
        getTaskInputDataCall(x.module, x.clientId)
        // }
        if (x.notifications.length > 0) {
          const notificationsIds = x?.notifications?.map((n: any) => n.id);
          console.log("x.n", x?.notifications?.map((n: any) => n.id))
          setTimeout(() => {
            userNotificationsCall(notificationsIds);
          }, 6000);

        }

      }
      setInitialListLoading(false);
    })

  }

  const getTaskInputDataCall = (module: any, clientId: any) => {
    setInputDataLoading(true);
    getTaskInputData(module, clientId).then((x) => {
      if (x.ErrorMessage) {
        dispatch(setErrorMsg(x.ErrorMessage));
        setTimeout(() => {
          dispatch(setErrorMsg(""));
        }, 4500);

      }
      else {
        // setAssigneesList(x.users);
        setInternalAssigneesList(x.internalUsers);
        if (userType === 2) setExternalAssigneesList(x.externalUsers);
        else {
          const selectedClientlientTMs = x.clients?.find((i: any) => i.id === clientId)?.users;
          setExternalAssigneesList(selectedClientlientTMs);
        }
        setClientsList(x.clients);
        setStatusesList(x.statuses);
        setTypesList(x.types);
        setModuleList(x.modules);
        setHistoryCategoriesList(x.historyCategory);
        setRecurringPeriodsList(x.recurringPeriods);
        // getTaskByIdCall(x.clients);
        setRemindersList(x.reminderTypes);

        setTimeout(() => {
          dispatch(setErrorMsg(""));
        }, 1000);
      }
      setInputDataLoading(false);
    })
  }

  // const getTaskListInputDataCall = () => {
  //   setInputDataLoading(true);
  //   getTaskListInputData().then((x) => {
  //     if (x.ErrorMessage) {
  //       dispatch(setErrorMsg(x.ErrorMessage));
  //       setTimeout(() => {
  //         dispatch(setErrorMsg(""));
  //       }, 4500);

  //     }
  //     else {
  //       // setAssigneesList(x.users);
  //       setInternalAssigneesList(x.internalUsers);
  //       if (userType === 2) setExternalAssigneesList(x.externalUsers);
  //       setClientsList(x.clients);
  //       setStatusesList(x.statuses);
  //       setTypesList(x.types);
  //       setModuleList(x.modules);
  //       setHistoryCategoriesList(x.historyCategory);
  //       setRecurringPeriodsList(x.recurringPeriods);
  //       getTaskByIdCall(x.clients);
  //       setRemindersList(x.reminderTypes);

  //       setTimeout(() => {
  //         dispatch(setErrorMsg(""));
  //       }, 1000);
  //     }
  //     setInputDataLoading(false);
  //   })
  // }

  const updateTaskCall = () => {
    dispatch(setLoading(true));
    let taskObj = {
      ...taskDetails, dueDate: moment(taskDetails.dueDate).format('YYYY-MM-DD'),
      startDate: moment(taskDetails.startDate).format('YYYY-MM-DD'),
      endDate: moment(taskDetails.endDate).format('YYYY-MM-DD')
    }

    // let taskObj = {
    //   id: taskId,
    //   title: taskDetails.title,
    //   dueDate: moment(taskDetails.dueDate).format('YYYY-MM-DD'),
    //   status: taskDetails.status,
    //   type: taskDetails.type,
    //   clientId: taskDetails.clientId,
    //   assigneeId: taskDetails.assigneeId,
    //   description: taskDetails.description,
    //   note: taskDetails.note,
    //   priority: taskDetails.priority,
    //   recurringPeriod:taskDetails.recurringPeriod

    // }
    updateTask(taskObj).then((x) => {
      if (x.ErrorMessage) {
        dispatch(setErrorMsg(x.ErrorMessage));
        dispatch(setCallStatus('Fail'));
        setTimeout(() => {
          dispatch(setErrorMsg(""));
          dispatch(setCallStatus(""));
          dispatch(setActionCallFrom(''))
        }, 1500);
      }
      else {
        dispatch(setCallStatus('Pass'));
        setTimeout(() => {
          dispatch(setErrorMsg(""));
          dispatch(setCallStatus(""));
          dispatch(setActionCallFrom(''))
          dispatch(setModify(!modify));
        }, 1500);

      }
      dispatch(setLoading(false));
    })
  }

  const updateTaskStatusCall = (taskId: string, statusId: number) => {
    dispatch(setLoading(true));
    if (statusId !== StatusesConsts.CLOSED_STATUS_ID && statusId !== StatusesConsts.OPEN_STATUS_ID) dispatch(setDialogLoading(true))
    updateTaskStatus(taskId, statusId).then((x) => {
      if (x.ErrorMessage) {
        dispatch(setErrorMsg(x.ErrorMessage));
        dispatch(setCallStatus('Fail'));
        setTimeout(() => {
          dispatch(setErrorMsg(""));
          dispatch(setCallStatus(""));
          dispatch(setActionCallFrom(''))
        }, 1500);
      }
      else {
        dispatch(setCallStatus('Pass'));
        setTimeout(() => {
          dispatch(setErrorMsg(""));
          dispatch(setCallStatus(""));
          dispatch(setActionCallFrom(''))
          if (statusId === StatusesConsts.CLOSED_STATUS_ID) navigate("/tasks")
          else if (statusId === StatusesConsts.OPEN_STATUS_ID) dispatch(setModify(!modify))
        }, 100);

      }
      dispatch(setLoading(false));
      dispatch(setDialogLoading(false))
    })
  }

  const addCommentCall = (commentObj: {}, files: File[]) => {
    setCommentLoading(true);
    addComment(commentObj, files).then((x) => {
      if (x.ErrorMessage) {
        dispatch(setErrorMsg(x.ErrorMessage));
        dispatch(setCallStatus('Fail'));
        setTimeout(() => {
          dispatch(setErrorMsg(""));
          dispatch(setCallStatus(""));
          dispatch(setActionCallFrom(''))
        }, 1500);
      }
      else {
        dispatch(setCallStatus('Pass'));
        setCommentTxt('');
        setCommentReplyTxt('');
        setCommentReplyFiles([]);
        setCommentFiles([])
        setIsFocused(false);
        setIsFocused1(false);
        setIsFocused2(false);
        localStorage.removeItem('comment')
        setTimeout(() => {
          dispatch(setErrorMsg(""));
          dispatch(setCallStatus(""));
          dispatch(setActionCallFrom(''))
          dispatch(setModify(!modify));
        }, 500);

      }
      setCommentLoading(false)
    })
  }

  const moveDocumentToDatevCall = (documentId: any) => {
    setMovingToDatevLoading(true);
    moveDocumentToDatev(documentId, taskId).then((x) => {
      if (x.ErrorMessage) {
        dispatch(setErrorMsg(x.ErrorMessage));
        dispatch(setCallStatus('Fail'));
        setTimeout(() => {
          dispatch(setErrorMsg(""));
          dispatch(setCallStatus(""));
          dispatch(setActionCallFrom(''))
        }, 1500);
      }
      else {
        if (localStorage.getItem('userType') === '1') {
          const object = {
            taskId: taskId,
            documents: [documentId]
          }
          setMovingToDatevLoading(true);
          moveAttachmentsToDatev(object).then((x) => {
            if (x.ErrorMessage) {
              dispatch(setErrorMsg(x.ErrorMessage));
              dispatch(setCallStatus('Fail'));
              setTimeout(() => {
                dispatch(setErrorMsg(""));
                dispatch(setCallStatus(""));
                dispatch(setActionCallFrom(''))
              }, 1500);
            }
            else {
              dispatch(setCallStatus('Pass'));
              dispatch(setErrorMsg(""));
              dispatch(setCallStatus(""));
              dispatch(setActionCallFrom(''))
              dispatch(setModify(!modify));
            }
            setMovingToDatevLoading(false);
          })
        }
        else {
          dispatch(setCallStatus('Pass'));
          dispatch(setErrorMsg(""));
          dispatch(setCallStatus(""));
          dispatch(setActionCallFrom(''))
          dispatch(setModify(!modify));

        }

      }
      setMovingToDatevLoading(false);
    })

  }

  const moveAttachmentsToDatevCall = (filesToMove: any) => {
    //const docsIds = filesToMove?.map((f:any)=> f.id);
    const object = {
      taskId: taskId,
      documents: filesToMove
    }

    if (taskId) {
      console.log("docs", filesToMove)
      setMovingToDatevLoading(true);
      moveAttachmentsToDatev(object).then((x) => {
        if (x.ErrorMessage) {
          dispatch(setErrorMsg(x.ErrorMessage));
          dispatch(setCallStatus('Fail'));
          setTimeout(() => {
            dispatch(setErrorMsg(""));
            dispatch(setCallStatus(""));
            dispatch(setActionCallFrom(''))
          }, 1500);
        }
        else {
          dispatch(setCallStatus('Pass'));
          dispatch(setErrorMsg(""));
          dispatch(setCallStatus(""));
          dispatch(setActionCallFrom(''))
          dispatch(setModify(!modify));
        }
        setMovingToDatevLoading(false);
      })

    }


  }


  const uploadTaskDocumentCall = (newFiles: any) => {
    //let newFiles = files?.filter((i) => !i.hasOwnProperty('id'))
    if (taskId) {
      setFileLoading('Upload');
      dispatch(setActionCallFrom('updateDocuments'))
      uploadTaskDocument(taskId, newFiles).then((x) => {
        if (x.ErrorMessage) {
          dispatch(setErrorMsg(x.ErrorMessage));
          dispatch(setCallStatus('Fail'));
          setTimeout(() => {
            dispatch(setErrorMsg(''));
            dispatch(setCallStatus(''));
            dispatch(setActionCallFrom(''))
          }, 4500)
        }
        else {
          dispatch(setCallStatus("Pass"));
          setTimeout(() => {
            dispatch(setErrorMsg(""));
            dispatch(setCallStatus(""));
            dispatch(setActionCallFrom(''))
          }, 2000);

          getTaskByIdCall(clientsList);
        }
        setFileLoading('');
      })
    }
  }

  const deleteTaskDocumentCall = (documentId: any, item: any) => {
    const index = files.indexOf(item);

    if (documentId) {
      setFileLoading('Delete');
      deleteTaskDocument(documentId).then((x) => {
        if (x.ErrorMessage) {
          dispatch(setErrorMsg(x.ErrorMessage));
          dispatch(setCallStatus('Fail'));
          setTimeout(() => {
            dispatch(setErrorMsg(''));
            dispatch(setCallStatus(''))
          }, 4500)
        }
        else {
          if (index > -1) {
            let tmp = files;
            files.splice(index, 1);
            setFiles(tmp)
            console.log(tmp)

          }
          getTaskByIdCall(clientsList);
        }
        setFileLoading('');
      })
    }
    else {
      if (index > -1) {
        console.log("index to be removed", index)
        const filesArray = Array.from(files);
        filesArray.splice(index, 1);
        setFiles(filesArray);
      }
    }
  }
  const downloadFileCall = (blobName: string, fileName: string) => {
    console.log("file name", fileName)
    setFileLoading('Download');
    dispatch(setActionCallFrom('downloadDocuments'))
    downloadFile(blobName).then((x) => {
      if (x.ErrorMessage) {
        dispatch(setErrorMsg(x.ErrorMessage));
        dispatch(setCallStatus('Fail'));
        setTimeout(() => {
          dispatch(setErrorMsg(''));
          dispatch(setCallStatus(''))
          dispatch(setActionCallFrom(''))
        }, 4500)
      }
      else {
        const link = document.createElement('a');
        link.href = x;
        link.download = fileName;

        // Append to the body to ensure it's in the document
        document.body.appendChild(link);
        link.click();

        // Clean up
        document.body.removeChild(link);
      }
      setFileLoading('');

    })
  }


  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const uploadedFiles = event.target.files;
    if (uploadedFiles) {
      const filesArray = Array.from(uploadedFiles);

      const duplicateFiles = filesArray?.filter((file) =>
        files?.some((existingFile) => existingFile.name === file.name)
      );

      if (duplicateFiles.length > 0) {
        setDocError("Cannot add files with the same name.");
        setTimeout(() => {
          setDocError('');
        }, 2000);
        event.target.value = '';
        return;
      }

      const combinedArray = [...filesArray, ...files];
      setFiles(combinedArray);
      // uploadTaskDocumentCall(filesArray);
      uploadTaskDocumentCall(filesArray);
      event.target.value = '';
    }
  };

  const deleteTaskCall = () => {
    dispatch(setLoading(true));
    deleteTask(selectedTaskToDelete.id).then((x) => {
      if (x.ErrorMessage) {
        dispatch(setErrorMsg(x.ErrorMessage));
        dispatch(setCallStatus('Fail'));
        setTimeout(() => {
          dispatch(setErrorMsg(''));
          dispatch(setCallStatus(''))
        }, 4500)
      }
      else {
        dispatch(setCallStatus('Pass'));
        setTimeout(() => {
          dispatch(setErrorMsg(''));
          dispatch(setCallStatus(''));
          setOpenDeleteDialog(false);
          dispatch(setModify(!modify))
        }, 1000)
        navigate('/tasks')
      }
      dispatch(setLoading(false));
    })
  }

  const addTaskCall = (taskObject: {}, buttonNb: any) => {
    dispatch(setLoading(true));
    addTask(taskObject).then((x) => {
      if (x.ErrorMessage) {
        dispatch(setErrorMsg(x.ErrorMessage));
        dispatch(setCallStatus("Fail"));
        setTimeout(() => {
          dispatch(setErrorMsg(""));
          dispatch(setCallStatus(""));
        }, 4500);

      }
      else {
        dispatch(setCallStatus("Pass"));
        setTimeout(() => {
          dispatch(setErrorMsg(""));
          dispatch(setCallStatus(""));
          setOpenAddTaskDialog(false);
          if (buttonNb === 1) {
            setOpenAddTaskDialog(false);
            dispatch(setModify(!modify));
          }
          if (buttonNb === 2) navigate(`/task-details?id=${x}`)

        }, 1000);
      }
      dispatch(setLoading(false));
    })

  }

  const userNotificationsCall = (notificationsIds: []) => {

    userNotifications(notificationsIds).then((x) => {
      if (x.ErrorMessage) {
        dispatch(setErrorMsg(x.ErrorMessage));
        setTimeout(() => {
          dispatch(setErrorMsg(""));
          dispatch(setActionCallFrom(''))
        }, 4500);

      }
      else {
        setOpenCustomReminder(false);
        dispatch(setActionCallFrom(''))
      }

    })


  }

  const postReminderCall = (reminderObj: any, reminderId: any) => {
    if (reminderId) {

      if (reminderObj.typeId === 4) dispatch(setLoading(true))
      else dispatch(setDialogLoading(true))
      dispatch(setActionCallFrom('post reminder'))
      inActiveReminder(reminderId).then((x) => {
        if (x.ErrorMessage) {
          dispatch(setErrorMsg(x.ErrorMessage));
          setTimeout(() => {
            dispatch(setErrorMsg(""));
          }, 4500);

        }
        else {
          if (reminderObj.typeId === 4) dispatch(setLoading(true))
          else dispatch(setDialogLoading(true))
          dispatch(setActionCallFrom('post reminder'))
          postReminder(reminderObj).then((x) => {
            if (x.ErrorMessage) {
              dispatch(setErrorMsg(x.ErrorMessage));
              setTimeout(() => {
                dispatch(setErrorMsg(""));
                dispatch(setActionCallFrom(''))
              }, 4500);

            }
            else {
              setOpenCustomReminder(false);
              dispatch(setModify(!modify));
              dispatch(setActionCallFrom(''))
            }
            dispatch(setLoading(false))
            dispatch(setDialogLoading(false))

          })


        }
      })


    }
    else {
      if (reminderObj.typeId === 4) dispatch(setLoading(true))
      else dispatch(setDialogLoading(true))
      dispatch(setActionCallFrom('post reminder'))
      postReminder(reminderObj).then((x) => {
        if (x.ErrorMessage) {
          dispatch(setErrorMsg(x.ErrorMessage));
          setTimeout(() => {
            dispatch(setErrorMsg(""));
            dispatch(setActionCallFrom(''))
          }, 4500);

        }
        else {
          dispatch(setDialogLoading(false))
          setOpenCustomReminder(false);
          dispatch(setModify(!modify));
          dispatch(setActionCallFrom(''))
        }
        if (reminderObj.typeId === 4) dispatch(setLoading(false))
        else dispatch(setDialogLoading(false))

      })
    }

  }

  const inActiveReminderCall = (reminderId: string) => {
    dispatch(setDialogLoading(true))
    inActiveReminder(reminderId).then((x) => {
      if (x.ErrorMessage) {
        dispatch(setErrorMsg(x.ErrorMessage));
        setTimeout(() => {
          dispatch(setErrorMsg(""));
        }, 4500);

      }
      else {
        dispatch(setModify(!modify));

      }
      dispatch(setDialogLoading(false))
    })

  }

  const postCustomRecurringCall = (obj: any) => {
    dispatch(setLoading(true))
    postCustomRecurring(obj).then((x) => {
      if (x.ErrorMessage) {
        dispatch(setErrorMsg(x.ErrorMessage));
        dispatch(setCallStatus("Fail"));
        setTimeout(() => {
          dispatch(setErrorMsg(""));
          dispatch(setCallStatus(""));
          dispatch(setActionCallFrom(''));
        }, 4500);
      } else {
        dispatch(setCallStatus("Pass"));
        setTimeout(() => {
          dispatch(setErrorMsg(""));
          dispatch(setCallStatus(""));
          dispatch(setActionCallFrom(''));
          setOpenCustomRecurringDialog(false);
          dispatch(setModify(!modify));
        }, 1000);
      }
      dispatch(setLoading(false))
    })
  }

  return (
    <Grid item container>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={dialogLoading || initiallistLoading || inputDataLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      {unAuthorized ?
        <Unauthorized navigateTo='/tasks' />
        :
        // statusesList?.length > 0 && assigneesList?.length > 0 && taskDetails?.status && taskDetails?.assigneeId ?
        statusesList?.length > 0 && taskDetails?.status ?
          <TaskDetailsContainer
            openRightDrawer={openRightDrawer}
            setOpenRightDrawer={setOpenRightDrawer}
            taskDetails={taskDetails}
            assigneesList={assigneesList}
            internalAssigneesList={internalAssigneesList}
            externalAssigneesList={externalAssigneesList}
            clientsList={clientsList}
            statusesList={statusesList}
            typesList={typesList}
            moduleList={moduleList}
            historyCategoriesList={historyCategoriesList}
            updateTaskCall={updateTaskCall}
            addCommentCall={addCommentCall}
            moveDocumentToDatevCall={moveDocumentToDatevCall}
            movingToDatevLoading={movingToDatevLoading}
            commentLoading={commentLoading}
            commentTxt={commentTxt}
            setCommentTxt={setCommentTxt}
            commentReplyTxt={commentReplyTxt}
            setCommentReplyTxt={setCommentReplyTxt}
            commentReplyFiles={commentReplyFiles}
            setCommentReplyFiles={setCommentReplyFiles}
            commentFiles={commentFiles}
            setCommentFiles={setCommentFiles}
            handleFileChange={handleFileChange}
            fileLoading={fileLoading}
            deleteTaskDocumentCall={deleteTaskDocumentCall}
            uploadTaskDocumentCall={uploadTaskDocumentCall}
            files={files}
            recurringPeriodsList={recurringPeriodsList}
            isFocused={isFocused}
            setIsFocused={setIsFocused}
            setIsFocused1={setIsFocused1}
            isFocused2={isFocused2}
            setIsFocused2={setIsFocused2}
            taskObject={taskObject}
            setTaskObject={setTaskObject}
            open={openAddTaskDialog}
            setOpen={setOpenAddTaskDialog}
            setOpenDeleteDialog={setOpenDeleteDialog}
            setselectedTaskToDelete={setselectedTaskToDelete}
            updateTaskStatusCall={updateTaskStatusCall}
            remindersList={remindersList}
            postReminderCall={postReminderCall}
            inActiveReminderCall={inActiveReminderCall}
            setOpenCustomReminder={setOpenCustomReminder}
            openCustomReminder={openCustomReminder}
            moveAttachmentsToDatevCall={moveAttachmentsToDatevCall}
            docError={docError}
            openCustomRecurring={openCustomRecurringDialog}
            setOpenCustomRecurring={setOpenCustomRecurringDialog}
            downloadFileCall={downloadFileCall}
            onBoardingDetails={onBoardingDetails}
            setOnBoardingDetails = {setOnBoardingDetails}
          />
          :
          <></>
      }

      <CreateTask
        loading={loading}
        open={openAddTaskDialog}
        setOpen={setOpenAddTaskDialog}
        callStatus={callStatus}
        errorMsg={errorMsg}
        confirmAction={addTaskCall}
        assigneesList={assigneesList}
        clientsList={clientsList}
        statusesList={statusesList}
        typesList={typesList}
        moduleList={moduleList}
        recurringPeriodsList={recurringPeriodsList}
        internalAssigneesList={internalAssigneesList}
        setInternalAssigneesList={setInternalAssigneesList}
        externalAssigneesList={externalAssigneesList}
        setExternalAssigneesList={setExternalAssigneesList}
        taskObject={taskObject}
        setTaskObject={setTaskObject}
        inputDataLoading={inputDataLoading}
      />

      <DeleteDialog
        openDeleteDialog={openDeleteDialog}
        setOpenDeleteDialog={setOpenDeleteDialog}
        loading={loading}
        callStatus={callStatus}
        errorMsg={errorMsg}
        object={selectedTaskToDelete}
        confirmAction={deleteTaskCall}
        type='task'
      />

      <CustomRecurringDialog
        open={openCustomRecurringDialog}
        setOpen={setOpenCustomRecurringDialog}
        confirmAction={postCustomRecurringCall}
        taskId={taskId}
        recurringObject={recurringObject}
        setRecurringObject={setRecurringObject}
        originalRecurringObject={originalRecurringObject}
      />
    </Grid>
  )
}

export default TaskDetails